import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-chained-backend";

// EN
import * as EN from "./translations/en";

// BN
import * as BN from "./translations/bn";

// HI
import * as HI from "./translations/hi";

// KM
import * as KM from "./translations/km";

// kn-IN
import * as KNIN from "./translations/kn-IN";

// LO
import * as LO from "./translations/lo";

// mr-IN
import * as MRIN from "./translations/mr-IN";

// MY
import * as MY from "./translations/my";

// ta-IN
import * as TAIN from "./translations/ta-IN";

// te-IN
import * as TEIN from "./translations/te-IN";

// tl-IN
import * as TLIN from "./translations/tl-PH";

// VI
import * as VI from "./translations/vi";

// TH
import * as TH from "./translations/th";

import { checkClearLang } from "@utils/ManageLang";
import countryLangStore from "@zustand/countryLang";
import { IFileKeys } from "@interface/ICommon";
import { translationData } from "@utils/translation";

let langStorage: string;

// get value localStorage start
try {
  const { lang } = countryLangStore();

  const persistLang = lang;
  langStorage = persistLang ?? `${process.env.REACT_APP_COUNTRY_LANG}`;
  if (checkClearLang(persistLang)) {
    langStorage = `${process.env.REACT_APP_COUNTRY_LANG}`;
  }
} catch (error) {
  console.error("get value localStorage start :>> ", error);
  langStorage = `${process.env.REACT_APP_COUNTRY_LANG}`;
}

const FileKeys: IFileKeys = {
  ...VI,
  ...EN,
  ...BN,
  ...HI,
  ...KM,
  ...KNIN,
  ...LO,
  ...MRIN,
  ...MY,
  ...TAIN,
  ...TEIN,
  ...TLIN,
  ...TH,
};

const translationKeys = [
  "Home",
  "Manage-Transaction",
  "Form-Common",
  "Sell-Transport",
  "Modal",
  "Login",
  "Search",
  "Reserve",
  "Planning",
  "Contract",
  "Common",
  "Error",
  "TransactionCPI",
];

const translateData = translationData(translationKeys, FileKeys);

i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init(
    {
      backend: {
        crossDomain: true,
        allowMultiLoading: true,
      },
      resources: translateData,
      supportedLngs: [
        "my",
        "bn",
        "hi",
        "mr-IN",
        "kn-IN",
        "km",
        "ta-IN",
        "vi",
        "lo",
        "tl-PH",
        "te-IN",
        "en",
        "th",
      ],
      lng: langStorage,
      fallbackLng: `${process.env.REACT_APP_COUNTRY_LANG}`, // use en if detected lng is not available
      debug: false,
      interpolation: {
        escapeValue: false, // react already safes from xss
      },

      ns: translationKeys,
      defaultNS: "Home",
    },
    (error) => {
      if (error) {
        console.error("error :>> ", error);
      }
    }
  );
